import React from 'react'
import * as Fields from 'support/fields'
import { Fieldset } from 'layouts/index'
import EditFormSmartview from 'widgets/smartviews/partials/EditFormSmartview'
import SmartviewHeader from 'widgets/smartviews/partials/SmartviewHeader'
import { Pipeline } from '@morningtrain/react-helpers'
import { ExecuteOperationOnPipe, ResetFormOnPipe, TriggerPipelineOnFormSubmit } from '@morningtrain/react-resources'

export default class CreateAdminUserSmartview extends EditFormSmartview {
  static get defaultProps () {
    return {
      ...super.defaultProps,
      goBackOnClickOutside: true
    }
  }

  get resourceName () {
    return 'users.admins'
  }

  get heading () {
    return 'Opret admin bruger'
  }

  get fields () {
    return (
      <>
        <SmartviewHeader>
          {this.heading}
        </SmartviewHeader>
        <Fieldset cols={1}>
          <Fields.Input name='name' label='Navn' />
          <Fields.Input name='email' label='E-mail' />
          <Fields.Hidden name='role_name' defaultValue='admin' />
        </Fieldset>
        <Pipeline>
          <TriggerPipelineOnFormSubmit />
          <ExecuteOperationOnPipe operationName='index' />
          <ResetFormOnPipe />
        </Pipeline>
      </>
    )
  }
}
